/* ============================================================
   InLei® Warenkorb-Schublade — Zusatzverhalten

   Die Schublade selbst (oeffnen, schliessen, Fokusfalle) und die
   Aktualisierung nach Mengenaenderungen kommen vom Theme
   (global.js / cart.js). Diese Datei ergaenzt nur, was serverseitig
   nicht geht:

   1. Hinweisleiste mit mehreren, durch "|" getrennten Texten
   2. Empfehlungen aus der Produktempfehlungs-Route nachladen,
      dabei alles aussortieren, was schon im Warenkorb liegt
   3. Pfeiltasten fuer die Empfehlungsschiene
   4. Tastaturbedienung fuer <add-to-cart> (ist kein <button>)

   Alles laeuft ueber einen MutationObserver auf <mini-cart>, weil das
   Theme den Inhalt der Schublade bei jeder Aenderung komplett durch
   frisches Server-HTML ersetzt.
   ============================================================ */
(function () {
  'use strict';

  var HINWEIS_INTERVALL = 5000;
  var hinweisTimer = null;
  var hinweisFeld = null;

  function wenigerBewegung() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------- 1. Hinweisleiste ---------- */
  function hinweisStarten(wurzel) {
    var feld = wurzel.querySelector('[data-inlei-wk-hinweise]');

    // Der Textwechsel loest selbst eine DOM-Aenderung aus. Ohne diese
    // Pruefung wuerde der Beobachter den Lauf jedes Mal neu starten und
    // die Leiste haenge zwischen den ersten beiden Texten fest.
    if (feld && feld === hinweisFeld && hinweisTimer) return;

    if (hinweisTimer) {
      window.clearInterval(hinweisTimer);
      hinweisTimer = null;
    }
    hinweisFeld = feld;
    if (!feld) return;

    var texte = (feld.getAttribute('data-inlei-wk-hinweise') || '')
      .split('|')
      .map(function (t) { return t.trim(); })
      .filter(Boolean);

    if (texte.length < 2) return;

    var index = 0;
    hinweisTimer = window.setInterval(function () {
      if (!feld.isConnected) {
        window.clearInterval(hinweisTimer);
        hinweisTimer = null;
        return;
      }
      index = (index + 1) % texte.length;

      if (wenigerBewegung()) {
        feld.textContent = texte[index];
        return;
      }

      feld.classList.add('is-wechselnd');
      window.setTimeout(function () {
        feld.textContent = texte[index];
        feld.classList.remove('is-wechselnd');
      }, 250);
    }, HINWEIS_INTERVALL);
  }

  /* ---------- 2. + 3. Empfehlungen ---------- */
  function empfehlungenLaden(wurzel) {
    var kasten = wurzel.querySelector('[data-inlei-wk-empfehlungen]');
    if (!kasten || kasten.dataset.gestartet === 'ja') return;
    kasten.dataset.gestartet = 'ja';

    var produktId = kasten.dataset.produktId;
    var basis = kasten.dataset.url || '/recommendations/products';
    if (!produktId) return;

    var imWarenkorb = (kasten.dataset.imWarenkorb || '')
      .split(',')
      .map(function (id) { return id.trim(); })
      .filter(Boolean);

    var maximum = parseInt(kasten.dataset.max, 10);
    if (!maximum || maximum < 1) maximum = 6;

    var adresse = basis
      + (basis.indexOf('?') === -1 ? '?' : '&')
      + 'section_id=inlei-warenkorb-empfehlungen'
      + '&product_id=' + encodeURIComponent(produktId)
      + '&limit=10&intent=related';

    fetch(adresse)
      .then(function (antwort) {
        if (!antwort.ok) throw new Error('Empfehlungen nicht erreichbar');
        return antwort.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var spur = doc.querySelector('.inlei-wk__spur');
        if (!spur) return;

        Array.prototype.slice.call(spur.querySelectorAll('.inlei-wk__karte')).forEach(function (karte) {
          var id = karte.getAttribute('data-produkt-id');
          if (imWarenkorb.indexOf(id) !== -1) karte.remove();
        });

        var karten = spur.querySelectorAll('.inlei-wk__karte');
        if (!karten.length) return;

        Array.prototype.slice.call(karten, maximum).forEach(function (karte) {
          karte.remove();
        });

        aufbauen(kasten, spur);
      })
      .catch(function (fehler) {
        // Empfehlungen sind Beiwerk — bei einem Fehler bleibt der Kasten leer.
        if (window.console) console.warn('[InLei Warenkorb]', fehler.message);
      });
  }

  function aufbauen(kasten, spur) {
    var titel = kasten.dataset.titel || '';

    var kopf = document.createElement('div');
    kopf.className = 'inlei-wk__empfehlungen-kopf';

    var ueberschrift = document.createElement('h3');
    ueberschrift.textContent = titel;
    kopf.appendChild(ueberschrift);

    var pfeile = document.createElement('div');
    pfeile.className = 'inlei-wk__pfeile';
    var zurueck = pfeilBauen('zurueck');
    var vor = pfeilBauen('vor');
    pfeile.appendChild(zurueck);
    pfeile.appendChild(vor);
    kopf.appendChild(pfeile);

    kasten.appendChild(kopf);
    kasten.appendChild(spur);
    kasten.hidden = false;

    function schrittweite() {
      var karte = spur.querySelector('.inlei-wk__karte');
      if (!karte) return 200;
      return karte.getBoundingClientRect().width + 12;
    }

    zurueck.addEventListener('click', function () {
      spur.scrollBy({ left: -schrittweite(), behavior: wenigerBewegung() ? 'auto' : 'smooth' });
    });
    vor.addEventListener('click', function () {
      spur.scrollBy({ left: schrittweite(), behavior: wenigerBewegung() ? 'auto' : 'smooth' });
    });

    function pfeileAktualisieren() {
      var rest = spur.scrollWidth - spur.clientWidth;
      zurueck.disabled = spur.scrollLeft <= 2;
      vor.disabled = spur.scrollLeft >= rest - 2;
      pfeile.hidden = rest <= 2;
    }

    spur.addEventListener('scroll', pfeileAktualisieren, { passive: true });
    window.requestAnimationFrame(pfeileAktualisieren);
  }

  function pfeilBauen(richtung) {
    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'inlei-wk__pfeil';
    knopf.setAttribute('aria-label', richtung === 'vor' ? 'Weitere Empfehlungen' : 'Vorherige Empfehlungen');
    knopf.innerHTML =
      '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true" focusable="false">'
      + '<path d="' + (richtung === 'vor' ? 'M4 1.5L8.5 6 4 10.5' : 'M8 1.5L3.5 6 8 10.5')
      + '" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return knopf;
  }

  /* ---------- 4. Tastatur fuer <add-to-cart> ---------- */
  function tastaturVerdrahten(wurzel) {
    if (wurzel.dataset.inleiWkTastatur === 'ja') return;
    wurzel.dataset.inleiWkTastatur = 'ja';

    wurzel.addEventListener('keydown', function (ereignis) {
      if (ereignis.key !== 'Enter' && ereignis.key !== ' ') return;
      var ziel = ereignis.target.closest ? ereignis.target.closest('add-to-cart') : null;
      if (!ziel) return;
      ereignis.preventDefault();
      ziel.click();
    });
  }

  /* ---------- Anstossen ---------- */
  function aufbereiten() {
    var schublade = document.getElementById('mini-cart');
    if (!schublade) return;
    var wurzel = schublade.querySelector('.inlei-wk');
    if (!wurzel) return;

    hinweisStarten(wurzel);
    empfehlungenLaden(wurzel);
  }

  function starten() {
    var schublade = document.getElementById('mini-cart');
    if (!schublade) return;

    tastaturVerdrahten(schublade);

    var geplant = false;
    new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      window.requestAnimationFrame(function () {
        geplant = false;
        aufbereiten();
      });
    }).observe(schublade, { childList: true, subtree: true });

    aufbereiten();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }

  document.addEventListener('shopify:section:load', starten);
})();
